<header class="header" id="home">
  <div class="container">
    <div class="row">
      <nav class="navbar navbar-expand-lg navbar-light header__nav">
        <div class="container-fluid">
          <div class="dropdown">
            <a
              class="dropdown-toggle"
              href="#"
              role="button"
              id="dropdownMenuLink"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="fas fa-globe-americas"></i>

              <span>{{ selectedLanguage == "en" ? "EN" : "PT" }}</span>
            </a>

            <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <li>
                <a class="" (click)="selectLanguage('en')">
                  <p class="language-english">
                    {{ "Menu.Language.en" | translate }}
                  </p>
                </a>
              </li>
              <li>
                <a class="" (click)="selectLanguage('pt')">
                  <p class="language-pt">
                    {{ "Menu.Language.pt" | translate }}
                  </p>
                </a>
              </li>
            </ul>
          </div>
          <button
            class="navbar-toggler menu-mobile"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div
            class="collapse navbar-collapse header__list animate__animated animate__fadeInRight"
            id="navbarNav"
          >
            <ul class="navbar-nav">
              <li class="nav-item">
                <a class="" href="#about">{{ "Menu.About" | translate }}</a>
              </li>

              <li class="nav-item">
                <a class="active" aria-current="page" href="#skills">
                  {{ "Menu.Skills" | translate }}</a
                >
              </li>

              <li class="nav-item">
                <a class="" href="#projects">{{
                  "Menu.Projects" | translate
                }}</a>
              </li>

              <li class="nav-item">
                <a class="btn-menu btn-sagan" href="#contact">{{
                  "Menu.ContactUs" | translate
                }}</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </div>
</header>
<main class="main-content">
  <div class="container">
    <div class="row">
      <div
        class="col-12 col-md-6 center-alignment animate__animated animate__fadeInRight"
      >
        <p class="main-content--title">
          {{ "Main-content.title.one" | translate }}
        </p>
        <h1 class="colored-text main-content--title-two">
          {{ "Main-content.title.two" | translate }}
        </h1>
        <p class="main-content--text colored-text">
          {{ "Main-content.text" | translate }}
        </p>
      </div>

      <div
        class="col-12 col-md-6 animate__animated animate__fadeInRight center-alignment"
      >
        <img
          class="animate__animated animate__pulse animate__repeat-3 home-web"
          src="assets/img/art/home-web.svg"
          alt="Home"
          title="Home"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div id="section10" class="main-content-scroll">
          <a href="#about">
            <span></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</main>
<!-- About -->
<article class="about" id="about">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center">
        <h2 class="main-content--title">{{ "About.title" | translate }}</h2>
      </div>
      <div class="col-12 text-center">
        <h4>
          <span class="colored-text">{{ "About.text" | translate }}</span>
        </h4>
      </div>
    </div>
    <div class="row about__line">
      <div
        class="col-12 col-md-6 animate__animated animate__fadeInRight text-center center-alignment"
      >
        <img
          class="animate__animated animate__pulse animate__repeat-3 team"
          src="assets/img/art/team.svg"
          alt="{{ 'About.title' | translate }}"
          title="{{ 'About.title' | translate }}"
        />
      </div>
      <div class="col-12 col-md-6 center-alignment about__text">
        <p>
          {{ "About.about-text.one" | translate }}
        </p>
        <p>
          {{ "About.about-text.two" | translate }}
        </p>
        <div class="about__tag">
          <span class="colored-text">{{ "About.tag" | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</article>
<!-- Skills -->
<article class="skills" id="skills">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center">
        <h2 class="main-content--title">{{ "Skills.title" | translate }}</h2>
      </div>
      <div class="col-12 text-center">
        <h4>
          <span class="colored-text">{{ "Skills.text" | translate }}</span>
        </h4>
      </div>
    </div>
    <div class="row skills__line">
      <div class="col-12 col-md-6 offset-md-3 center-alignment">
        <div class="row">
          <!-- skills__column-one -->
          <div class="col-3">
            <div class="skills__column-one">
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/angular.svg"
                  alt="Angular"
                  title="Angular"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/html.svg"
                  alt="HTML"
                  title="HTML"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/css.svg"
                  alt="CSS"
                  title="CSS"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/cordova.svg"
                  alt="Cordova"
                  title="Cordova"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/aws-logo.svg"
                  alt="AWS"
                  title="AWS"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/wordpress.svg"
                  alt="WordPress"
                  title="WordPress"
                />
              </div>
            </div>
          </div>
          <!-- skills__column-two -->
          <div class="col-3">
            <div class="skills__column-two">
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/react-icon.svg"
                  alt="React"
                  title="React"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/git.svg"
                  alt="Git"
                  title="Git"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/bootstrap-4.svg"
                  alt="Bootstrap"
                  title="Bootstrap"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/docker.svg"
                  alt="Docker"
                  title="Docker"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/php.svg"
                  alt="PHP"
                  title="PHP"
                />
              </div>
            </div>
          </div>
          <!-- skills__column-thre -->
          <div class="col-3">
            <div class="skills__column-thre">
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/ionic.svg"
                  alt="Ionic"
                  title="Ionic"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/typescript.svg"
                  alt="TypeScript"
                  title="TypeScript"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/capacitor-js.svg"
                  alt="Capacitor"
                  title="Capacitor"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/firebase.svg"
                  alt="Firebase"
                  title="Firebase"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/mongodb.svg"
                  alt="Mongodb"
                  title="Mongodb"
                />
              </div>
            </div>
          </div>
          <!-- skills__column-four -->
          <div class="col-3">
            <div class="skills__column-four">
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/javascript.svg"
                  alt="JavaScript"
                  title="JavaScript"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/ngrx.svg"
                  alt="NgRx Angular"
                  title="NgRx Angular"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/jquery-colored-.svg"
                  alt="Jquery"
                  title="Jquery"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/vscode.svg"
                  alt="VsCode"
                  title="VsCode"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/nodejs-icon.svg"
                  alt="NodeJS"
                  title="NodeJS"
                />
              </div>
              <div class="skills__column-box">
                <img
                  src="../../assets/img/skills/postman.svg"
                  alt="Postman"
                  title="Postman"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</article>
<!-- projects -->
<article class="projects" id="projects">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center">
        <h2 class="main-content--title">{{ "Projects.title" | translate }}</h2>
      </div>
      <div class="col-12 text-center">
        <h4>
          <span class="colored-text">{{ "Projects.text" | translate }}</span>
        </h4>
      </div>
    </div>
    <div class="row mt-5 mb-5">
      <owl-carousel-o [options]="customOptions" class="owl-carousel-o">
        <ng-template carouselSlide *ngFor="let item of projectsList">
          <div class="services-box">
            <div class="row">
              <div class="col-12 col-sm-6">
                <img
                  style="background-image: url('{{ item.img }}');"
                  alt=""
                  class="services-box--icon"
                />
              </div>
              <div class="col-12 col-sm-6">
                <div class="row">
                  <div class="col-12">
                    <h5 class="colored-text">
                      {{ item.name }}
                    </h5>
                    <p>
                      {{
                        selectedLanguage == "en"
                          ? item.descriptionEN
                          : item.descriptionPT
                      }}
                    </p>
                  </div>
                  <div class="col-12" style="margin-bottom: 1rem">
                    <span
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                      ><img
                        [src]="tech"
                        *ngFor="let tech of item.tech"
                        style="width: 7%; margin: 0 0.2rem"
                    /></span>
                    <span> </span>
                  </div>
                  <div class="col-12">
                    <a
                      [href]="item.link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button type="button" class="btn-sagan">
                        {{ "Services.know-more" | translate }}
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </owl-carousel-o>
      <div class="col-12 col-md-3 text-center"></div>
    </div>
  </div>
</article>

<article class="contact" id="contact">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center">
        <h2 class="main-content--title">
          {{ "Contact.title" | translate }}
        </h2>
      </div>
      <div class="col-12 text-center">
        <h4>
          <span class="colored-text">
            {{ "Contact.text" | translate }}
          </span>
        </h4>
      </div>
    </div>
    <div class="row contact__line">
      <div class="col-12 col-md-6 center-alignment">
        <img
          class="animate__animated animate__pulse animate__repeat-3 contact-img"
          src="assets/img/art/contact.svg"
        />
      </div>
      <div class="col-12 col-md-6 center-alignment">
        <div class="contact__box-form">
          <form class="contact__form" [formGroup]="formLogin">
            <div class="row mb-4">
              <div class="col-12 text-center">
                <h5 class="colored-text">
                  <!--  -->
                  {{ "Contact.form.title" | translate }}
                </h5>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 col-md-3 center-alignment">
                <label>{{ "Contact.form.name" | translate }}</label>
              </div>
              <div class="col-12 col-md-9 center-alignment">
                <input
                  type="text"
                  placeholder="{{
                    'Contact.form.name-placeholder' | translate
                  }}"
                  formControlName="name"
                  matInput
                />
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 col-md-3 center-alignment">
                <label>{{ "Contact.form.email" | translate }}</label>
              </div>
              <div class="col-12 col-md-9 center-alignment">
                <input
                  type="email"
                  placeholder="{{
                    'Contact.form.email-placeholder' | translate
                  }}"
                  formControlName="email"
                />
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-12 col-md-3 center-alignment">
                <label>{{ "Contact.form.phone" | translate }}</label>
              </div>
              <div class="col-12 col-md-9 center-alignment">
                <input
                  type="tel"
                  placeholder="{{
                    'Contact.form.phone-placeholder' | translate
                  }}"
                  formControlName="phone"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-3">
                <label>{{ "Contact.form.message" | translate }}</label>
              </div>
              <div class="col-12 col-md-9 center-alignment">
                <textarea
                  formControlName="message"
                  rows="3"
                  placeholder="{{
                    'Contact.form.message-placeholder' | translate
                  }}"
                ></textarea>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-12 text-end">
                <button
                  class="btn-sagan"
                  matButton
                  (click)="onClick()"
                  [disabled]="!formLogin.value"
                >
                  <span *ngIf="!loading">{{
                    "Contact.form.submit" | translate
                  }}</span>
                  <div *ngIf="loading" class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </button>
              </div>
              <div
                *ngIf="sucesso"
                class="alert-success alert-styles mt-2"
                role="alert"
              >
                Enviado com sucesso!
              </div>
              <div
                *ngIf="error"
                class="alert-danger alert-styles mt-2"
                role="alert"
              >
                Erro ao enviar, Tentar novamente!
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</article>
<footer class="footer">
  <div class="footer__back-to-top">
    <a href="#home">
      <i class="fas fa-chevron-up"></i>
    </a>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-12 text-center footer__box">
        <span class="footer__box-line"></span>
      </div>
      <div class="col-12 text-center footer__social-links">
        <a
          href="https://github.com/jefersonwillian"
          target="_blank"
          title="GitHub Jeferson Carvalho"
        >
          <i class="fab fa-github"></i>
        </a>
        <a
          href="https://www.linkedin.com/in/jeferson-willian-carvalho/"
          target="_blank"
          title="Linkedin Jeferson Carvalho"
        >
          <i class="fab fa-linkedin"></i>
        </a>
        <a href="mailto:jeferson.wc@mail.co.uk" title="jeferson.wc@mail.co.uk">
          <i class="far fa-envelope"></i>
        </a>
        <a
          href="https://api.whatsapp.com/send?phone=447840402506"
          target="_blank"
          title="Contato via WhatsApp Jeferson Carvalho"
          ><i class="fab fa-whatsapp"></i
        ></a>
      </div>
      <div class="col-12 text-center footer__copyright">
        <p>{{ "Footer.title" | translate }}</p>
      </div>
    </div>
  </div>
</footer>
